

export const animeTypes = [
  {
    label: "动漫",
    value: 1,
    subTypes: [
      {
        label: "哩番",
        value: 1,
      },
      {
        label: "3D",
        value: 2,
      },
      {
        label: "同人动画",
        value: 3,
      },
    ]
  },
  {
    label: "漫画",
    value: 2,
    subTypes: [
      {
        label: "单行本",
        value: 4,
      },
      {
        label: "连载漫画",
        value: 5,
      },
      {
        label: "韩漫",
        value: 6,
      },
    ]
  },
  {
    label: "小说",
    value: 3,
    subTypes: [
      {
        label: "有声小说",
        value: 7,
      },
      {
        label: "文字小说",
        value: 8,
      },
    ]
  },
  {
    label: "剧场",
    value: 4,
    subTypes: [
      {
        label: "剧场动漫",
        value: 9,
      },
    ]
  },
  {
    label: "短剧",
    value: 5,
    subTypes: [
      {
        label: "短剧剧场",
        value: 10,
      },
    ]
  },
]

export const allSubTypes = []
animeTypes.map(v => v.subTypes).forEach(v => {
  allSubTypes.push(...v)
})
